export const style = {
  accountFont: "monospace",
  accountFontSize: 15,
  btnColor: "#1E90FF",
  btnTextColor: "#fff",
  bgColor: "grey",
  labelColor: "#87CEEB",
};
